export class Endpoints {
  private static readonly users = "/users";
  private static readonly products = "/products";
  private static readonly orders = "/orders";
  private static readonly sizes = "/sizes";
  private static readonly generalCategories = "/generalcategories";
  private static readonly subCategories = "/subcategories";
  private static readonly categories = "/categories";
  private static readonly discounts = "/discounts";
  private static readonly configs = "/configs";

  /**
   * method: GET
   */
  public static readonly home = "/home";

  // users
  /**
   * method: POST
   */
  static readonly loginWithPassword = `${Endpoints.users}/loginwithpassword`;
  /**
   * method: GET
   */
  static readonly infoUser = `${Endpoints.users}/info`;

  // products
  /**
   * method: GET
   */
  static readonly productInfo = `${Endpoints.products}/info`;
  /**
   * method: POST
   */
  static readonly listProducts = `${Endpoints.products}/list`;
  /**
   * method: POST
   */
  static readonly addProduct = `${Endpoints.products}/add`;
  /**
   * method: POST
   */
  static readonly editProduct = `${Endpoints.products}/edit`;
  /**
   * method: POST
   */
  static readonly addAttributeToProduct = `${Endpoints.products}/new-attribute`;
  /**
   * method: POST
   */
  static readonly removeProduct = `${Endpoints.products}/remove`;
  /**
   * method: PATCH
   */
  static readonly setProductAttributesPrice = `${Endpoints.products}/edit-product-price`;
  /**
   * method: PATCH
   */
  static readonly setProductAttributesOffPrice = `${Endpoints.products}/edit-product-off-price`;
  /**
   * method: PATCH
   */
  static readonly setProductAttributesCount = `${Endpoints.products}/edit-product-count`;
  /**
   * method: DELETE
   */
  static readonly deleteImageFromProduct = `${Endpoints.products}/delete-image`;
  /**
   * method: PATCH
   */
  static readonly addImageToProduct = `${Endpoints.products}/add-image`;
  /**
   * method: PATCH
   */
  static readonly editProductImage = `${Endpoints.products}/edit-image`;

  // orders
  /**
   * method: GET
   */
  static readonly listOrders = `${Endpoints.orders}/list`;
  /**
   * method: POST
   */
  static readonly editOrder = `${Endpoints.orders}/edit`;
  /**
   * method: POST
   */
  static readonly sendOrderInfo = `${Endpoints.orders}/send-order-info`;
  /**
   * method: PATCH
   */
  static readonly toggleIsPackaged = `${Endpoints.orders}/toggle-is-packaged`;

  // sizes
  /**
   * method: GET
   */
  static readonly sizesList = `${Endpoints.sizes}/list`;

  // colors
  /**
   * method: GET, POST, PATCH, DELETE
   */
  static readonly colors = "/color/";

  // generalCategories
  /**
   * method: GET
   */
  static readonly listGeneralCategories = `${Endpoints.generalCategories}/list`;
  /**
   * method: POST
   */
  static readonly addGeneralCategory = `${Endpoints.generalCategories}/add`;
  /**
   * method: POST
   */
  static readonly removeGeneralCategory = `${Endpoints.generalCategories}/remove`;

  // subCategories
  /**
   * method: POST
   */
  static readonly addSubCategory = `${Endpoints.subCategories}/add`;
  /**
   * method: POST
   */
  static readonly removeSubCategory = `${Endpoints.subCategories}/remove`;

  // categories
  /**
   * method: POST
   */
  static readonly addCategory = `${Endpoints.categories}/add`;
  /**
   * method: POST
   */
  static readonly removeCategory = `${Endpoints.categories}/remove`;
  /**
   * method: PATCH
   */
  static readonly editCategory = `${Endpoints.categories}`;

  // discount
  /**
   * method: POST
   */
  static readonly addDiscount = `${Endpoints.discounts}/add`;
  /**
   * method: POST
   */
  static readonly removeDiscount = `${Endpoints.discounts}/remove`;
  /**
   * method: GET
   */
  static readonly listDiscounts = `${Endpoints.discounts}/list`;

  // configs
  /**
   * method: GET
   */
  static readonly editConfigs = `${Endpoints.configs}/edit`;
  /**
   * method: GET
   */
  static readonly listConfigs = `${Endpoints.configs}/list`;

  /**
   * methods: POST, PATCH, DELETE
   */
  public static readonly slider = "/slider/";

  /**
   * methods: POST, PATCH, DELETE
   */
  public static readonly homeSection = "/home-section/";
}
